import React from "react";
import { t } from "i18next";
import { AppstoreOutlined, DashboardOutlined, BarChartOutlined, SettingOutlined, SafetyOutlined, AppstoreAddOutlined } from '@ant-design/icons';
import {SECURITY_UI_URL} from "../../../../../constants/config.constant";


export const LeftSidebarMenu = [
    {
        type: 'item',
        title: t("Dashboard"),
        permission: 'eticket:menu:adminPanel:dashboard',
        link: { to: '/dashboard', exactMatch: true, externalUrl: false, openInNewTab: false },
        icon: <DashboardOutlined />,
        class: '',
        badge: '',
        badgeClass: '',
        hidden: false,
    },
    {
        type: 'item',
        title: t('My Apps'),
        permission: 'eticket:menu:adminPanel:myApps',
        link: { to: `${SECURITY_UI_URL}/admin`, exactMatch: true, externalUrl: true, openInNewTab: false },
        icon: <AppstoreOutlined />,
        class: '',
        badge: '',
        badgeClass: '',
        hidden: false,
    },
    {
        type: 'item',
        title: t('Eticket'),
        permission: 'eticket:menu:adminPanel:eticket',
        link: { to: '/e-ticket/holiday', exactMatch: true, externalUrl: false, openInNewTab: false },
        icon: <SafetyOutlined />,
        class: '',
        badge: '',
        badgeClass: '',
        hidden: false,
    },
    {
        type: 'item',
        title: t('Report'),
        permission: 'eticket:menu:adminPanel:report',
        link: { to: '/report', exactMatch: true, externalUrl: false, openInNewTab: false },
        icon: <BarChartOutlined />,
        class: '',
        badge: '',
        badgeClass: '',
        hidden: false,
    },
    {
        type: 'item',
        title: t('Setup'),
        permission: 'eticket:menu:adminPanel:setup',
        link: { to: `${SECURITY_UI_URL}/admin/en/setup/all`, exactMatch: true, externalUrl: true, openInNewTab: false },
        icon: <AppstoreAddOutlined />,
        class: '',
        badge: '',
        badgeClass: '',
        hidden: false,
    },
    {
        type: 'item',
        title: t('Setting'),
        permission: 'eticket:menu:adminPanel:setting',
        link: { to: '/setting/ticket-timeout', exactMatch: true, externalUrl: false, openInNewTab: false },
        icon: <SettingOutlined />,
        class: '',
        badge: '',
        badgeClass: '',
        hidden: false,
    }
];
